import { Center, Stack } from '@mantine/core';
import type { PolicyViolationOut } from '@repo/api-codegen';
import { Icon, Text } from '@repo/foundations';
import { memo } from 'react';
import { PolicyBreakdownItem } from './PolicyBreakdownItem';

interface PolicyBreakdownListProps {
	violations: PolicyViolationOut[];
}

export const PolicyBreakdownList = memo(
	({ violations }: PolicyBreakdownListProps) => {
		if (violations.length === 0) {
			return (
				<Center p="xl">
					<Stack align="center" p="md">
						<Icon name="circleCheck" size="lg" color="icon/success/default" />
						<Text size="sm">No issues</Text>
					</Stack>
				</Center>
			);
		}

		return (
			<div>
				{violations.map((violation) => (
					<PolicyBreakdownItem key={violation.id} violation={violation} />
				))}
			</div>
		);
	}
);

PolicyBreakdownList.displayName = 'PolicyBreakdownList';
